module.exports = __webpack_public_path__ + "static/media/IMG_0082.6d32b63e.jpg";